





















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { MortgageCardProps, MortgageOffer } from './types';

@Component
export default class MortgageCard extends Vue implements MortgageCardProps {
    /**
     *
     */
    @Prop()
    public readonly cardData!: MortgageOffer;
}
